import { MutableRefObject } from "react";
import { saveAs } from "file-saver";
import { v4 as uuidv4 } from "uuid";

import { GenericObject } from "@/@types/generics/genericals";

export function exportExcel(data: GenericObject[], fileName?: string) {
	const worker = new Worker(new URL("../../workers/excelWorker.ts", import.meta.url), {
		type: "module",
	});

	return new Promise<void>((resolve, reject) => {
		worker.postMessage({ data });

		worker.onmessage = (event) => {
			const { success, buffer, error } = event.data;

			if (!success) {
				reject(new Error(error));
				return;
			}

			const fileType =
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
			const fileExtension = "xlsx";

			const blob = new Blob([buffer], { type: fileType });

			saveAs(blob, `${fileName || uuidv4()}.${fileExtension}`);

			resolve();
		};

		worker.onerror = (e) => reject(e);
	});
}

export function extractTable(tableRef: MutableRefObject<HTMLTableElement | null>) {
	const table = tableRef.current;

	const tableHeaders = Array.from(table?.querySelectorAll("thead th") || []).map((thead) => {
		if (!thead.classList.contains("no-excel")) {
			return thead.textContent;
		}

		return "";
	});

	const data = Array.from(table?.querySelectorAll("tbody tr") || []).map((row) => {
		const rowData = {} as GenericObject;

		row.querySelectorAll("td").forEach((cell, index) => {
			if (!cell.classList.contains("no-excel")) {
				const key = tableHeaders[index] as string;

				rowData[key] = (cell.dataset.content || cell.textContent)?.toUpperCase();
			}
		});

		return rowData;
	});

	return data;
}
